// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import {
    AutocompleteModel,
    BadgeModel,
    OrderModel,
    ProductAutocompleteItemModel,
    ProductModel,
    QuoteModel,
    SessionModel,
} from "@insite/client-framework/Types/ApiModels";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

export type xBaseTheme = BaseTheme & { helpers: any };

export type xBlueprintName = "pacific" | "mastersource";

export interface HelpersGroup {
    [key: string]: CallableFunction;
}

export interface CustomSessoinModel extends SessionModel {
    defaultWarehouse: {
        hours: string;
        email: string;
        phone: string;
        contactName: string;
    };
    phone: string;
}
export interface GroupByAttribute {
    attributeValueIds: string[];
    groupKey: string;
    imageAltText: string;
    imagePath: string;
}
export interface CustomCatalogPageState extends CatalogPage {
    columnsAttributeTypes: string[];
    groupByAttributes: GroupByAttribute[];
}

export interface ProductListTableLevel {
    [key: string]: {
        products: ProductModel[];
    };
}

export interface BackorderModel {
    productErpNumber: string;
    description: string;
    erpOrderNumber: string;
    customerPo: string;
    qtyOrdered: number;
    orderDate: string;
}

export interface XBadgeModel extends BadgeModel {
    borderColor?: string;
}

export interface IneterestCategoriesModel {
    interestCategories: IneterestCategoryModel[];
}
export interface IneterestCategoryModel {
    name: string;
    interests: InterestModel[];
}
export interface InterestModel {
    name: string;
    id: string;
    subscribed: boolean;
}
export interface XngAutocompleteModel extends AutocompleteModel {
    products: XngProductAutocompleteItemModel[] | null;
}

export interface XngProductAutocompleteItemModel extends ProductAutocompleteItemModel {
    upcCode?: string;
    cantBuy?: boolean;
    canAddToCart?: boolean;
    canConfigure?: boolean;
    trackInventory?: boolean;
    isQuoteRequired?: boolean;
    minimumOrderQty?: number;
}

export interface RfqQuoteModel extends QuoteModel {
    salesperson?: {
        name?: string;
        phone1?: string;
        email?: string;
    };
}

export interface XngOrderModel extends OrderModel {
    pickupWarehouse?: any;
}

export const enum SearchInputTypes {
    keyword = "keyword",
    unifiedSearch = "UnifiedSearch",
    imageSearch = "ImageSearch",
}
